import { useMemo } from 'react';
import { FormProvider } from 'react-hook-form';
import { FilterDrawer, RhfSelect } from '@core/components';
import { useFilterDrawer } from '@core/hooks/useFilterDrawer';
import { useAppContext } from '../context/AppContext';
import {
  type CustomerFilters,
  EMPTY_CUSTOMER_FILTERS,
} from '../utils/customer';

interface CustomerFilterDrawerProps {
  open: boolean;
  filters: CustomerFilters;
  onApply: (filters: CustomerFilters) => void;
  onClear: () => void;
  onClose: () => void;
}

const CustomerFilterDrawer: React.FC<CustomerFilterDrawerProps> = ({
  open,
  filters,
  onApply,
  onClear,
  onClose,
}) => {
  const { dioceses } = useAppContext();
  const { methods, handleApply, handleClear } = useFilterDrawer({
    open,
    filters,
    emptyFilters: EMPTY_CUSTOMER_FILTERS,
    onApply,
    onClear,
  });

  const dioceseOptions = useMemo(
    () => [
      { value: '', label: 'All dioceses' },
      ...dioceses.map((diocese) => ({
        value: String(diocese.id),
        label: diocese.name,
      })),
    ],
    [dioceses]
  );

  return (
    <FormProvider {...methods}>
      <FilterDrawer
        open={open}
        title="Filter customers"
        onApply={handleApply}
        onClear={handleClear}
        onClose={onClose}
      >
        <RhfSelect<CustomerFilters>
          name="dioceseId"
          label="Diocese"
          options={dioceseOptions}
        />
      </FilterDrawer>
    </FormProvider>
  );
};

export default CustomerFilterDrawer;
